import { useState } from 'react'

import { Alert } from '@atoms'
import AsyncSelect from '@molecules/AsyncSelect'

import { useSupporterAutocomplete, type SupporterSearchOption, type SupporterSearchResult } from './useSupporterAutocomplete'

import { scopedTranslation } from '@utils/I18n'

const t = scopedTranslation('supporter_create.search')

type SupporterAutocompleteSelectProps = {
  groupId: string
  onSelect: (supporter: SupporterSearchResult) => void
}

export function SupporterAutocompleteSelect({ groupId, onSelect }: SupporterAutocompleteSelectProps) {
  const { loadOptions } = useSupporterAutocomplete({ groupId })
  const [selectedOption, setSelectedOption] = useState<SupporterSearchOption | null>(null)

  const handleChange = (option: SupporterSearchOption) => {
    setSelectedOption(option)
    if (option?.data) {
      onSelect(option.data)
    }
  }

  return (
    <div className="tw:flex tw:flex-col tw:gap-2">
      <AsyncSelect
        displayName={t('label')}
        name="supporterSearch"
        loadOptions={loadOptions}
        onChange={handleChange}
        value={selectedOption ?? undefined}
        isCreatable={false}
        isMulti={false}
        isClearable={true}
        placeholder={t('placeholder')}
        noOptionsMessage={t('no_results')}
      />
      <p className="tw:text-sm tw:text-gray-600">{t('description')}</p>
      {selectedOption?.data?.memberOfGroup && (
        <Alert type="info" title={t('already_in_group')} />
      )}
    </div>
  )
}
